export const Types = {
    GET_EXCEL_TEMPLATE : "GET_EXCEL_TEMPLATE",

    GET_MASTER_DATA_EXCEL_JSON : "GET_EXCEL_JSON",
    SET_MASTER_DATA_EXCEL_JSON : "SET_EXCEL_JSON",

    UPLOAD_EXCEL_FILE : "UPLOAD_EXCEL_FILE",
    UPLOAD_EXCEL_FILE_RESPONSE: "UPLOAD_EXCEL_FILE_RESPONSE"
};

export const downloadExcelTemplate = () => ({
    type: Types.GET_EXCEL_TEMPLATE
});

export const getExcelJsonData = (payload) => ({
    type: Types.GET_MASTER_DATA_EXCEL_JSON,
    payload: payload
});

export const setExcelJsonData = (payload) => ({
    type: Types.SET_MASTER_DATA_EXCEL_JSON,
    payload:payload
});

export const uploadExcelFile = (payload) => ({
    type: Types.UPLOAD_EXCEL_FILE,
    payload: payload
});

export const uploadExcelFileResponse = (payload) => ({
    type: Types.UPLOAD_EXCEL_FILE_RESPONSE,
    payload: payload
});

